import { useRef, useState, useEffect } from "react";

const onLoadListeners = [];
let apiScriptRequested = false;
let captchaReady = false;

const mountCaptchaScript = () => {
  if (apiScriptRequested) return;
  apiScriptRequested = true;
  window.hcaptchaOnLoad = () => {
    onLoadListeners.forEach((fn) => fn());
    captchaReady = true;
  };

  const script = document.createElement("script");
  script.src = `https://js.hcaptcha.com/1/api.js?render=explicit&onload=hcaptchaOnLoad`;
  script.async = true;
  document.head.appendChild(script);
};

export const useCaptcha = ({ onVerify }) => {
  const [ready, setReady] = useState(captchaReady);
  const [node, setNode] = useState(null);
  const cbRef = useRef({ onVerify });
  useEffect(() => {
    cbRef.current = { onVerify };
  });

  useEffect(() => {
    if (node) mountCaptchaScript();
  }, [node]);
  useEffect(() => {
    if (!ready) {
      onLoadListeners.push(() => setReady(true));
    } else if (node) {
      if (!window.hcaptcha) {
        console.warn("couldn't find `window.hcaptcha`");
        return undefined;
      }
      const id = window.hcaptcha.render(node, {
        sitekey: import.meta.env.VITE_HCAPTCHA_SITEKEY,
        theme: "dark",
        callback: (response) => cbRef.current.onVerify(response),
        "expired-callback": () => console.warn("hcaptcha expired"),
        "error-callback": (err) => {
          console.error("hcaptcha error", err);
          window.hcaptcha.reset(id);
        },
      });
      return () => window.hcaptcha.remove(id);
    }
  }, [node, ready]);

  return setNode;
};
